import { createTheme } from '@mui/material/styles';
import { colors } from './color-palette';

const { PURPLE, GREY, WHITE, PURPLE_INACTIVE, BlACK } = colors;

export const theme = createTheme({
	palette: {
		primary: {
			main: PURPLE,
		},
	},
	typography: {
		fontFamily: 'Bogle-Regular, sans-serif',
	},
	overrides: {
		MuiTypography: {
			root: {
				fontFamily: 'Bogle-Regular',
			},
			bold: {
				fontWeight: 700,
			},
		},
		MuiCheckbox: {
			root: {
				color: '#3B3B3B',
			},
			colorPrimary: {
				'&$disabled': {
					color: PURPLE_INACTIVE,
				},
				'&$checked': {
					'&:hover': {
						backgroundColor: '#F5F5F5',
					},
				},
			},
		},
		MuiButton: {
			root: {
				borderRadius: 100,
				'&.Mui-disabled': {
					backgroundColor: GREY,
				},
			},
			contained: {
				boxShadow: 'none',
				backgroundColor: PURPLE,

				'&:hover,&:active': {
					boxShadow: 'none',
				},
				'&.Mui-disabled': {
					color: WHITE,
					backgroundColor: GREY,
				},
			},
		},
		MuiSwitch: {
			switchBase: {
				color: '#F1F1F1',
			},
		},
		MuiRadio: {
			root: {
				color: '#3B3B3B',
				'&.Mui-checked': {
					color: '#3c228a !important',
					background: 'transparent !important',
				},
				'&:hover, &&:hover': {
					background: '#F5F5F5',
				},
			},
			colorPrimary: {
				'&.Mui-disabled': {
					color: '#3B3B3B',
					opacity: 0.26,
				},
			},
		},
		MuiAppBar: {
			colorPrimary: {
				color: BlACK,
				backgroundColor: WHITE,
			},
		},
		MuiTabs: {
			root: {
				height: 32,
				minHeight: 0,
			},
		},
		MuiTab: {
			root: {
				fontFamily: 'Bogle-Regular',
				minHeight: 32,
				textTransform: 'capitalize',
				'&$selected': {
					color: BlACK,
				},
				'@media (min-width: 600px)': {
					minWidth: 88,
					paddingBottom: 0,
				},
			},
			indicator: {
				display: 'flex',
				justifyContent: 'center',
				'& > span': {
					maxWidth: 40,
					width: '100%',
				},
			},
		},
	},
});
